module.exports = __webpack_public_path__ + "img/62400.6ef54b97.jpg";